let toasterQueue = [];
let lastReplacableToastId = null; // track last toast that opted into replacement

export const triggerAlert = ({
  message,
  title,
  type = 'info',
  parentClassName = '',
  children,
  replacePrevious = false, // if true, replaces the last replacable toast
  autoHideMs = 5000,
}) => {
  const id = Math.random().toString(36).substr(2, 9); // Generate a unique ID for each message

  if (replacePrevious && lastReplacableToastId) {
    // remove previous replacable toast
    removeAlert(lastReplacableToastId);
  }

  const toast = {
    id,
    type,
    message,
    title,
    parentClassName,
    children,
    replacePrevious,
  };
  toasterQueue.push(toast);

  if (replacePrevious) {
    lastReplacableToastId = id;
  }

  if (autoHideMs > 0) {
    setTimeout(() => {
      removeAlert(id);
      if (lastReplacableToastId === id) lastReplacableToastId = null;
    }, autoHideMs); // Auto-hide
  }
  return id; // allow manual removal if needed
};

export const removeAlert = (id) => {
  toasterQueue = toasterQueue.filter((toast) => toast.id !== id);
};

export const getToasterQueue = () => {
  return toasterQueue;
};

// Attach the triggerAlert function to the window object
window.triggerAlert = triggerAlert;
